<template>
  <v-container no-gutters>
    <template v-if="!isSent">
      <v-row no-gutters class="justify-center pb-6">
        <v-col cols="auto">
          <v-subheader class="text-h6 pa-0 font--text font-weight-regular" style="height: auto;">
            {{ $i18n.t('login.recoveryText') }}
          </v-subheader>
        </v-col>
      </v-row>
      <v-row no-gutters class="justify-center">
        <v-col cols="8" lg="7">
          <v-form v-model="isValid">
            <authentication-input
              validate-on-blur
              translation-path="login.email"
              :rules="[rules.required, isEmail]"
              v-model="credentials.email"
              class="pb-4"
            ></authentication-input>
            <v-row no-gutters class="justify-end">
              <v-col cols="auto" class="pr-2">
                <button-main-dialog
                  :small="false"
                  cancel
                  @click="$router.push({ name: 'login' })"
                  :text="$i18n.t('login.cancel')"
                />
              </v-col>
              <v-col cols="auto">
                <base-button
                  :loading="isLoading"
                  :disabled="!isValid"
                  @click="getResetPasswordLink"
                  translation-path="login.send"
                  style="margin-right: 0px !important;"
                ></base-button>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row no-gutters class="justify-center pb-6">
        <v-col cols="auto">
          <v-subheader class="text-h6 pa-0 font--text font-weight-regular" style="height: auto;">
            {{ $i18n.t('login.recoveryInfo') }}
          </v-subheader>
        </v-col>
      </v-row>
      <v-row no-gutters class="justify-end">
        <v-col cols="auto">
          <link-underlined
            translation-path="login.backToLogin"
            @click="$router.push({ name: 'login' })"
          ></link-underlined>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { call } from 'vuex-pathify';
import ButtonMainDialog from '@/components/ButtonMainDialog';
import AuthenticationInput from '@/components/AuthenticationInput';
import LinkUnderlined from '@/components/LinkUnderlined';

export default {
  name: 'Login',
  components: {
    AuthenticationInput,
    ButtonMainDialog,
    LinkUnderlined,
  },
  data: () => ({
    credentials: {
      email: '',
    },
    isSent: false,
    isValid: false,
    response: undefined,
    isLoading: false,
    rules: {
      required: v => !!v || 'rules.required',
    },
  }),
  computed: {
    isEmail() {
      return this.$_validateEmail(this.credentials.email) || 'rules.email';
    },
  },
  methods: {
    getResetPasswordLinkAction: call('authentication/getResetPasswordLink'),
    async getResetPasswordLink() {
      try {
        this.isLoading = true;
        await this.getResetPasswordLinkAction(this.credentials);
        this.isLoading = false;
      } catch (error) {
        console.log(`loginHandler -> error`, error.message);
        this.isLoading = false;
      }
      this.isSent = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
